type Assert = (condition: unknown, message?: string) => asserts condition;

export const assert: Assert = (condition: unknown, msg?: string): asserts condition => {
    if (!condition) {
        throw new Error(msg ?? "Invalid condition");
    }
};